import React from 'react';

import { shape, string } from 'prop-types';

import ClassNames from 'classnames';

import BaseComponent from '../../.internal/BaseComponent';

import './TableHead.scss';

export default class TableHead extends BaseComponent {
  render() {
    const { style, id, className, children } = this.props;

    const classNames = ClassNames(['TableHead', className]);

    return (
      <thead style={style} id={id} className={classNames}>
        {children}
      </thead>
    );
  }
}

TableHead.propTypes = {
  style: shape({}),
  id: string,
  className: string
};

TableHead.defaultProps = {
  style: {},
  id: undefined,
  className: undefined
};
